var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transfer-details',{attrs:{"translations":_vm.translations,"transfer-details":_vm.transferDetails,"loading":_vm.loading,"hide-sum":true},on:{"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }